import Vue from "vue";
import Router from "vue-router";
import store from "./store";

const Welcome = () =>
  import(/* webpackChunkName: "welcome" */ "./views/Welcome.vue");
const FindPathfinder = () =>
  import(/* webpackChunkName: "findPathfinder" */ "./views/FindPathfinder.vue");
const NewPathfinder = () =>
  import(/* webpackChunkName: "newPathfinder" */ "./views/NewPathfinder.vue");
const Customize = () =>
  import(/* webpackChunkName: "customize" */ "./views/Customize.vue");
const SelectLocation = () =>
  import(/* webpackChunkName: "selectLocation" */ "./views/SelectLocation.vue");
const Dashboard = () =>
  import(/* webpackChunkName: "dashboard" */ "./views/Dashboard.vue");

Vue.use(Router);

const redirectToHome = (to, from, next) => {
  if (store.state.pathfinders && store.state.pathfinders.pathfinder !== null) {
    next();
  } else {
    next("/");
  }
};

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "welcome",
      component: Welcome
    },
    {
      path: "/find",
      name: "find",
      component: FindPathfinder
    },
    {
      path: "/new",
      name: "new",
      component: NewPathfinder
    },
    {
      path: "/customize",
      name: "customize",
      component: Customize,
      beforeEnter: redirectToHome
    },
    {
      path: "/location",
      name: "location",
      component: SelectLocation,
      beforeEnter: redirectToHome
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      beforeEnter: redirectToHome
    }
  ]
});

export default router;
